import axios from 'axios'
import localforage from 'localforage'

const RESOURCE_NAME = '/counties'

export default {
  getAll (params) {
    if (navigator.onLine) {
      let apiParams = new URLSearchParams(window.location.search).toString()
      if (params) {
        apiParams = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&')
      }
      if (apiParams) {
        return axios.get(`${RESOURCE_NAME}?${apiParams.toString()}`)
      } else {
        return axios.get(`${RESOURCE_NAME}`)
      }
    } else {
      return this.getOfflineData()
    }
  },

  getOfflineData () {
    let urlParams = new URLSearchParams(window.location.search)
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      let counties = {
        data: {
          data: [],
          meta: {}
        }
      }
      // counties.data.data = localforage.getItem('counties')
      localforage.getItem('counties').then((response) => {
        let perPage = urlParams.get('per_page') ? urlParams.get('per_page') : 25
        let page = urlParams.get('page') ? urlParams.get('page') : 1
        page = page - 1
        let start = page * perPage
        let stop = parseInt(start, 10) + parseInt(perPage, 10)
        // SEARCH
        if (urlParams.get('q')) {
          let search = urlParams.get('q').toLowerCase()
          response = response.filter(function (data) {
            // return data
            if (data.first_name && data.first_name.toLowerCase().includes(search)) {
              return data
            }
            if (data.last_name && data.last_name.toLowerCase().includes(search)) {
              return data
            }
            if (data.phone && data.phone.toLowerCase().includes(search)) {
              return data
            }
            if (data.company_name && data.company_name.toLowerCase().includes(search)) {
              return data
            }
            if (data.county && data.county.name.toLowerCase().includes(search)) {
              return data
            }
            if (data.city && data.city.name.toLowerCase().includes(search)) {
              return data
            }
          })
        }
        // FILTER
        let city = urlParams.get('f_city') ? urlParams.get('f_city') : 0
        let county = urlParams.get('f_county') ? urlParams.get('f_county') : 0
        city = parseInt(city, 10)
        county = parseInt(county, 10)
        if (city > 0 || county > 0) {
          response = response.filter(function (data) {
            if (county > 0 && data.county && data.county.id === county) {
              if (city === 0) {
                return data
              }
              if (city > 0 && data.city && data.city.id === city) {
                return data
              }
            }
          })
        }
        // SORT
        // let sortBy = urlParams.get('sort_by') ? urlParams.get('sort_by') : null
        // let sortType = urlParams.get('sort_type') ? urlParams.get('sort_type') : 1
        // sortType = sortType === 'ASC' ? 1 : -1
        // if (sortBy) {
        //   if (sortBy === 'city' || sortBy === 'county') {
        //     // response.sort((a, b) => (a.sortBy > b.sortBy) ? 1 * sortType : (-1) * sortType)
        //     response.sort(function (a, b) {
        //       let sortA = a.sortBy != null ? a.sortBy.name : null
        //       let sortB = b.sortBy != null ? b.sortBy.name : null
        //       return (sortA < sortB) ? 1 * sortType : (-1) * sortType
        //     })
        //   } else {
        //     response.sort((a, b) => (a.sortBy > b.sortBy) ? 1 * sortType : (-1) * sortType)
        //   }
        // }
        // end SORT
        let total = response.length
        counties.data.data = response.slice(start, stop)
        counties.data.meta = {
          current_page: page + 1,
          from: start,
          last_page: Math.ceil(total / perPage),
          per_page: perPage,
          to: stop,
          total: total
        }
        resolve(counties)
      })
    })
  },

  getAllSync () {
    return axios.get(`${RESOURCE_NAME}?per_page=-1`)
  },

  get (id) {
    if (navigator.onLine) {
      return axios.get(`${RESOURCE_NAME}/${id}`)
    } else {
      return this.getOfflineDataById(id)
    }
  },

  create (data) {
    return axios.post(RESOURCE_NAME, data)
  },

  update (id, data) {
    return axios.post(`${RESOURCE_NAME}/${id}`, data)
  },

  delete (id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`)
  },

  getOfflineDataById (id) {
    return new Promise((resolve, reject) => {
      let countie = {
        data: {
          data: null
        }
      }
      localforage.getItem('counties').then((response) => {
        countie.data.data = response.find(x => x.id === id)
        resolve(countie)
      })
    })
  }
}
